<template>
  <div class="ndzd">
    <audio autoplay controls id="audio" src="../../assets/ndzd/ndzd.mp3"  ref="au" v-show="false"></audio>
    <div class="fullpage-container">
      <div class="fullpage-wp" v-fullpage="opts">
        <div class="page-1 page">
          <img src="../../assets/ndzd/1.png" />
          <!-- 内容盒子 -->
          <div class="content">
            <div class="touxiang">
              <img :src="zhangdan.hotelLogo" alt />
            </div>
            <!-- 酒店名字 -->
            <div class="hotel">{{ zhangdan.hotelName }}</div>

            <div class="one">感谢您使用星云PMS，</div>
            <div class="two">新的一年，</div>
            <div class="three">我们将竭诚为您服务。</div>
          </div>
          <!-- 立即开启 -->
          <!-- <div class="kaiqi">立即开启</div> -->
        </div>
        <div class="page-2 page">
          <img src="../../assets/ndzd/2.png" />
          <!-- 背景图片 -->
          <div class="con_one">
            <!-- <img src="" alt /> -->
            <div class="da_box">
              <div class="content_one">自 <span class="col1"> {{ zhangdan.startDay }} </span> 至今</div>
              <div class="content_two">星云PMS，</div>
              <div class="content_three">
                已陪伴您度过了<span class="col2">{{ zhangdan.days }}</span>天
              </div>
            </div>
            <!-- 预订订单 -->
            <div class="da_order">
              <div class="order">
                <div class="backg"></div>
                <div class="order_word">「预订单 <span class="col3">{{ zhangdan.revIn }} </span>单」</div>
              </div>
              <div class="ruzhu">
                <div class="backg_ruzhu"></div>
                <div class="ruzhu_word">
                  「直接入住 <span class="col4">{{ zhangdan.checkIn }} </span>单」
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-8 page" v-if="zhangdan.source != null">
          <!-- 背景图片 -->
          <img src="../../assets/ndzd/8.png" alt />
          <div class="con_eight">
            <div class="box_eight">
              <!-- 文字 -->
              <div class="wenzi">订单来源分析</div>
              <!-- 状图 -->
              <div id="myChart3" class="zhuangtu"></div>
            </div>
          </div>
        </div>
        <div class="page-3 page">
          <img src="../../assets/ndzd/3.png" />
          <div class="con_three">
            <div class="tou_three">
              <div class="three_word">酒店会员已达<span class="col5"> {{ zhangdan.member }} </span>人</div>
            </div>
            <div class="three_order">
              <div class="three_backg"></div>
              <div class="three_words">
                「共计接待了 <span class="col6"> {{ zhangdan.people }} </span> 位贵宾」
              </div>
            </div>
            <!-- 饼图 -->
            <div class="three_bing">
              <!-- 左图 -->
              <div class="bing_left">
                <img src="../../assets/ndzd/3-3.png" />
              </div>
              <!-- 右文字 -->
              <div class="bing_wenzi">
                <div class="female">女: {{ zhangdan.women }} 位</div>
                <div class="male">男: {{ zhangdan.men }} 位</div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-4 page">
          <img src="../../assets/ndzd/4.png" />

          <div class="con_four">
            <div class="four_order">
              <div class="four_backg"></div>
              <div class="four_words">「累计用房 <span class="col3">{{ zhangdan.useRoom }} </span> 间」</div>
            </div>
            <!-- 柱状图 -->
            <div class="four_zhu">
              <!-- 左图 -->
              <div id="myChart" style="width: 30rem" class="zhu_left"></div>
              <!-- <div ></div> -->
              <!-- 右文字 -->
            </div>
            <!-- <div class="zhu_wenzi">
              <div
                class="zhu_one"
                v-for="(item, idx) in useRoomType"
                :key="idx"
              >
               
                <div class="bj">
                  [{{ idx + 1 }}]{{ item[1] }} {{ item[2] }}间
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="page-5 page">
          <img src="../../assets/ndzd/5.png" />

          <div class="con_five">
            <div class="five_order">
              <div class="five_backg"></div>
              <div class="five_words">「累计收款 <span class="col4"> {{ zhangdan.amount }} </span>元」</div>
            </div>
            <!-- 折线图 -->
            <div class="shouyi">
              <div
                class="shouyione"
                v-for="(item, idx) in amountItem"
                :key="idx"
              >
                <div>{{ item[1] }}</div>
                <div>{{ item[3] }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-6 page">
          <img src="../../assets/ndzd/6.png" />

          <div class="con_six">
            <div class="img">
              <img :src="zhangdan.hotelLogo" alt />
            </div>
            <!-- 酒店名字 -->
            <div class="hote_name">{{ zhangdan.hotelName }}</div>

            <div class="xingyun">感谢您使用星云PMS</div>
            <!-- 虎图片 -->
            <div class="hu">
              <img src="../../assets/ndzd/6-1.png" alt />
            </div>
            <!-- 电话地址 -->
            <div class="photo">
              <div class="dainhua">电话：400 000 6966</div>
              <div class="dizhi">地址：常州市钟楼区运河路50号</div>
            </div>
            <!-- 公司 -->
            <div class="gongsi">常州邦威软件有限公司</div>
          </div>
        </div>
        <div class="page-7 page">
          <!-- <img src="../../assets/ndzd/7.png" /> -->
          <div class="con_sever">
            <!-- 上 -->
            <div class="shang">
              <div class="shang_left">
                <img class="img" src="../../assets/ndzd/7-1.png" alt />
                <div class="yuding">酒店预订</div>
                <div class="erweima">
                  <img class="ewmimg" src="../../assets/ndzd/ewm0.jpg" />
                </div>
              </div>
              <div class="shang_right">
                <img class="img" src="../../assets/ndzd/7-4.png" alt />
                <div class="yuding">移动前台</div>
                <div class="erweima">
                  <img class="ewmimg" src="../../assets/ndzd/ydqt.jpg" />
                </div>
              </div>
            </div>

            <!-- 下 -->
            <div class="xia">
              <div class="xia_left">
                <img class="img" src="../../assets/ndzd/7-2.png" alt />
                <div class="yuding">全球鹰</div>
                <div class="erweima">
                  <img class="ewmimg" src="../../assets/ndzd/qqy.jpg" />
                </div>
              </div>
              <div class="xia_right">
                <img class="img" src="../../assets/ndzd/7-3.png" alt />
                <div class="yuding">移动房务</div>
                <div class="erweima">
                  <img class="ewmimg" src="../../assets/ndzd/ydfw.jpg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRequest } from "@/api/api1.js";
import global from "../../Global.vue";
export default {
  name: "welcome",
  data() {
    return {
      image_base: this.$store.state.api,
      zhangdan: {},
      useRoomType: [],
      amountItem: [],
      source: [],
      opts: {
        start: 0,
        dir: "v",
        loop: false,
        duration: 500,
        stopPageScroll: false,
        beforeChange: function (prev, next) {},
        afterChange: function (prev, next) {},
      },
      src:''
    };
  },
  created() {
    if (this.$route.query.id != null || this.$route.query.id != "") {
      this.ndzd(this.$route.query.id);
      document.addEventListener("WeixinJSBridgeReady",function() { 
        document.getElementById('audio').play(); 
      }, false);
      document.addEventListener('touchstart', function () {
              function audioAutoPlay() {
                  var audio = document.getElementById('audio');
                      audio.play();
              }
              audioAutoPlay();
      });
    } else {
      //alert("未获取到酒店ID！");
      return;
    }
  },
  mounted() {
     document.body.addEventListener(
      "touchmove",
      function (e) {
        undefined;
        e.preventDefault();
      },
      { passive: false }
    );
    var that = this;
    setTimeout(() => {
        that.handleCanplay();
    }, 3000);
  },
  methods: {
    
    handleCanplay() {

      this.$nextTick(() => {
        this.$refs.au.play()
      })
    },
    getRoomType() {
      var data1 = [];
      var data2 = [];
      for (var i = 0; i < this.useRoomType.length; i++) {
        data1.push(this.useRoomType[i][1]);
        data2.push(this.useRoomType[i][2]);
      }
      for (var i = 0; i < this.useRoomType.length; i++) {
        // console.log(data1[i] + "??" + data2[i]);
      }

      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        grid: {
          left: "0%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: data1,
        },
        series: [
          {
            name: "",
            type: "bar",
            data: data2,
          },
        ],
      });
    },

    getSource() {
      var data1 = [];
      for (var i = 0; i < this.source.length; i++) {
        data1.push({
          value: this.source[i][1],
          name: this.source[i][3] + ":" + this.source[i][1],
        });
      }
      // console.log("11", data1);
      let myChart = this.$echarts.init(document.getElementById("myChart3"));
      // 绘制图表
      myChart.setOption({
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: "50%",
            data: data1,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },

    render(h) {
      return h(
        "div",
        {
          staticClass: "col-grow items-center text-center q-pa-sm",
        },
        [
          h(
            "v-touch",
            {
              on: {
                swipedown: () => {
                  this.selected = this.selected === 0 ? 0 : this.selected - 1;
                  if (this.selected === 0) {
                  }
                  //this.$q.ok("已到顶！")
                },
                swipeup: () => {
                  this.selected = this.selected === 3 ? 3 : this.selected + 1;
                  if (this.selected === 6) {
                    //this.$q.ok("已到底！")
                  }
                },
              },
            },
            [
              h("img", {
                style: {
                  height: "100%",
                  width: "400px",
                },
                attrs: {
                  // src: this.img_list[this.selected].src
                },
              }),
            ]
          ),
        ]
      );
    },
    ndzd(id) {
      let loadingInstance = this.$loading({ text: "正在加载年度账单..." });
      getRequest("annualBill/getAnnualBill?hotelId=" + id).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
          if (res.status == 200) {
            if (res.data.hotelLogo == null || res.data.hotelLogo == "") {
              res.data.hotelLogo =
                "http://www.bwipms.com/api/images/hotel/gtHiq4cl_logo1626138293335.jpg";
            } else {
              res.data.hotelLogo = global.api + res.data.hotelLogo;
            }

            this.zhangdan = res.data;
            var uryList = res.data.useRoomType.split("@");
            for (var i = 0; i < uryList.length; i++) {
              var uryOne = uryList[i].split("|");
              this.useRoomType.push(uryOne);
            }
            this.$nextTick(() => {
              this.getRoomType();
            });

            if (res.data.source != null && res.data.source.length > 0) {
              var sourceList = res.data.source.split("@");
              for (var i = 0; i < sourceList.length; i++) {
                var sourceOne = sourceList[i].split("|");
                this.source.push(sourceOne);
              }
              // console.log("123", this.source);
              this.$nextTick(() => {
                this.getSource();
              });
            }

            var amoumtList = res.data.amountItem.split("@");
            for (var i = 0; i < amoumtList.length; i++) {
              var amountOne = amoumtList[i].split("|");
              this.amountItem.push(amountOne);
            }
          } else {
            alert(res.message);
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.fizeweight {
  font-weight: bold;
}

* {
  margin: 0;
  padding: 0;
}
#app {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  color: red;
}
.page img {
  width: 100%;
  height: 100%;
}
.page-1 {
  background: rgba(0, 0, 0, 0.8);
}
.page-2 {
  /* background: url(../../assets/ndzd/2.png) no-repeat;
  background-size: 100% 100%; */
}
.page-3 {
  background: blueviolet;
}
.page-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 14rem;
  position: absolute;
  top: 37.5%;
}

.touxiang {
  width: 4rem;
  height: 4rem;

  border-radius: 0px;
  margin: 0 auto;
}
.hotel {
  margin: 0 auto;
  width: 100%;
  height: 2rem;
  font-size: 16px;
  font-weight: 500;
  line-height: 35px;
  color: #2d2d2d;
  margin-top: 4%;
  text-align: center;
  overflow: hidden;
}
.one {
  width: 100%;
  height: 1rem;
  font-size: 16px;
  font-weight: 400;
  color: #322b21;
  text-align: center;
  margin-top: 7%;
}
.two {
  width: 100%;
  height: 1rem;
  font-size: 16px;
  font-weight: 400;
  color: #322b21;
  text-align: center;
  margin-top: 5%;
}
.three {
  width: 100%;
  height: 1rem;
  font-size: 16px;
  font-weight: 400;
  color: #322b21;
  text-align: center;
  margin-top: 5%;
}
.kaiqi {
  position: absolute;
  left: 24.3%;
  top: 79.5%;
  width: 12rem;
  height: 3.5rem;
  text-align: center;
  background: #2d2d2d;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 400;
  line-height: 57px;
  color: #ffffff;
}
.con_one {
  width: 16.4rem;
  height: 15rem;
  position: absolute;
  left: 15%;
  top: 21.5%;
  background: url(../../assets/ndzd/2-1.png) no-repeat;
  background-size: 100% 100%;
}
.da_box {
  margin-top: 21%;
  padding-left: 9%;
  line-height: 24px;
}
.content_one {
  width: 100%;
  height: 1rem;
  font-size: 16px;
  font-weight: 400;
  color: #414141;
}
.content_two {
  width: 100%;
  height: 1rem;
  font-size: 16px;
  font-weight: 400;
  color: #414141;
  margin-top: 3%;
}
.content_three {
  width: 100%;
  height: 1rem;
  font-size: 16px;
  font-weight: 400;
  color: #414141;
  margin-top: 3%;
}
.da_order {
  padding-left: 12%;
}
.order {
  margin-top: 16%;
  position: relative;
}
.order_word {
  position: absolute;
  bottom: 47%;
  width: 240px;
  height: 32px;
  font-size: 18px;

  font-weight: 500;
  line-height: 48px;
  color: #272c28;
}
.backg {
  width: 8.7rem;
  height: 0.9rem;
  background: #94d6e6;
  border-radius: 0px;
}
.backg_ruzhu {
  width: 9.7rem;
  height: 0.9rem;
  background: #b7b9ff;
  border-radius: 0px;
}
.ruzhu {
  margin-top: 12%;
  position: relative;
}
.ruzhu_word {
  position: absolute;
  bottom: 47%;
  width: 240px;
  height: 32px;
  font-size: 18px;
  font-weight: 500;
  line-height: 48px;
  color: #272c28;
}
.con_three {
  width: 16.4rem;
  height: 17rem;
  position: absolute;
  left: 15%;
  top: 12.5%;
  background: url(../../assets/ndzd/3-1.png) no-repeat;
  background-size: 100% 100%;
}
.tou_three {
  margin-top: 22.5%;
  padding-left: 10%;
}
.three_word {
  width: 100%;
  height: 1rem;
  font-size: 16px;
  font-weight: 400;
  line-height: 0px;
  color: #414141;
}
.three_order {
  position: absolute;
  bottom: 50%;
  width: 100%;
  height: 2rem;
  font-size: 18px;
  font-weight: 500;
  line-height: 48px;
  color: #272c28;
  padding-left: 8%;
}
.three_backg {
  width: 13.2rem;
  height: 0.9rem;
  background: #a2f3dc;
  border-radius: 0px;
}
.three_words {
  position: absolute;
  bottom: 77%;
  width: 100%;
  height: 2rem;
  font-size: 18px;
  font-weight: 500;
  line-height: 48px;
  color: #272c28;
}
.three_bing {
  display: flex;
  margin-top: 30%;
  padding-left: 12%;
}
.bing_left {
  width: 6rem;
  height: 6rem;
}
.bing_wenzi {
  margin-top: 8.5%;
  margin-left: 10%;
}
.female {
  width: 5.2rem;
  height: 1.4rem;
  color: #fff;
  background: #fe5578;
  border-radius: 13px;
  line-height: 1.4rem;
  text-align: center;
  font-size: 12px;
}
.male {
  width: 5.2rem;
  height: 1.4rem;
  color: #fff;
  background: #1cd1a1;
  border-radius: 13px;
  line-height: 1.4rem;
  text-align: center;
  font-size: 12px;
  margin-top: 25%;
}
.con_four {
  width: 90%;
  position: absolute;
  left: 5%;
  top: 5%;
  background: url(../../assets/ndzd/4-1.png) no-repeat;
  background-size: 100%;
  padding: 5% 0%;
}
.four_order {
  position: absolute;
  top: 10%;

  height: 1.5rem;
  font-size: 18px;
  font-weight: 500;
  line-height: 48px;
  color: #272c28;
  padding-left: 12%;
}
.four_backg {
  width:12rem;
  height: 0.9rem;
  background: #ffe777;
  border-radius: 0px;
}
.four_words {
  position: absolute;
  bottom: 77%;
  width: 100%;
  height: 2rem;
  font-size: 18px;
  font-weight: 500;
  line-height: 48px;
  color: #272c28;
}
.four_zhu {
  display: flex;
  margin-top: 15%;

  width: 100%;
  background: #fff;
}
.zhu_left {
  width: 100%;
  height: 30rem;
}
.zhu_one {
  margin-bottom: 8px;
}
.one_yuan {
  margin: 0 5px;
  width: 0.3rem;
  height: 0.3rem;
  margin-top: 6px;
  border-radius: 50%;
  background-color: #1cd1a1;
}
.two_yuan {
  margin: 0 5px;
  width: 0.3rem;
  height: 0.3rem;
  margin-top: 6px;
  border-radius: 50%;
  background-color: #fe5578;
}
.three_yuan {
  margin: 0 5px;
  width: 0.3rem;
  height: 0.3rem;
  margin-top: 6px;
  border-radius: 50%;
  background-color: #fe5578;
}
.four_yuan {
  margin: 0 5px;
  width: 0.3rem;
  height: 0.3rem;
  margin-top: 6px;
  border-radius: 50%;
  background-color: #feca57;
}
.bj {
  font-size: 12px;
}
.con_five {
  width: 90%;
  height: 30rem;
  position: absolute;
  left: 5%;
  top: 10%;
  background: url(../../assets/ndzd/5-1.png) no-repeat;
  background-size: 100%;
}
.five_order {
  position: absolute;
  top: 15%;
  width: 100%;
  height: 2rem;
  font-size: 18px;
  font-weight: 500;
  line-height: 48px;
  color: #272c28;
  padding-left: 12%;
}
.five_backg {
  width: 86%;
  height: 0.9rem;
  background: #97e8f8;
  border-radius: 0px;
}
.five_words {
  position: absolute;
  bottom: 77%;
  width: 100%;
  height: 2rem;
  font-size: 18px;
  font-weight: 500;
  line-height: 48px;
  color: #272c28;
}
.zhexian {
  width: 90%;
  height: 8rem;
  margin-top: 45%;
  margin-left: 10%;
}
.con_six {
  width: 100%;
  position: absolute;
  top: 25.5%;
}
.img {
  width: 4rem;
  height: 4rem;
  border-radius: 0px;
  margin: 0 auto;
}
.hote_name {
  width: 100%;
  text-align: center;
  width: 100%;
  height: 2rem;
  font-size: 16px;
  font-weight: 500;
  line-height: 52px;
  color: #2d2d2d;
}
.xingyun {
  height: 2rem;
  font-size: 16px;
  font-weight: 400;
  line-height: 48px;
  color: #272c28;
  text-align: center;
  margin-top: 8%;
}
.hu {
  width: 100%;
  text-align: center;
  margin-top: 14%;
}
.hu img {
  width: 13rem;
}
.photo {
  margin-top: 9%;
}
.dainhua {
  width: 100%;
  text-align: center;
  font-size: 16px;
  height: 2rem;
  font-weight: 400;
  line-height: 42px;
  color: #272c28;
}
.dizhi {
  width: 100%;
  text-align: center;
  font-size: 16px;
  height: 2rem;
  font-weight: 400;
  line-height: 42px;
  color: #272c28;
}
.gongsi {
  width: 100%;
  text-align: center;
  font-size: 15px;
  height: 2rem;
  font-weight: 400;
  line-height: 42px;
  color: #272c28;
}
.con_sever {
  width: 100%;
  height: 100%;
  background: url(../../assets/ndzd/7.png) no-repeat;
  background-size: 100% 100%;
}
.shang {
  display: flex;
  justify-content: center;
  padding-top: 65%;
  margin-bottom: 10%;
}
.shang_left {
  /* margin-left: 16.5%; */
  position: relative;
}
.shang_left .img {
  width: 7rem;
  height: 9rem;
}
.shang_right {
  margin-left: 25px;
  position: relative;
}
.shang_right .img {
  width: 7rem;
  height: 9rem;
}
.xia_left {
  position: relative;
}
.xia_left .img {
  width: 7rem;
  height: 9rem;
}
.xia_right {
  position: relative;
  margin-left: 25px;
}
.xia_right .img {
  width: 7rem;
  height: 9rem;
}
.xia {
  display: flex;
  margin-top: 13%;
  justify-content: center;
}
.yuding {
  position: absolute;
  left: 21%;
  top: 13%;
  font-size: 16px;
}
.erweima {
  width: 5rem;
  height: 5rem;
  background: pink;
  position: absolute;
  left: 15%;
  top: 34%;
}
.con_eight {
  width: 100%;
}
.box_eight {
  width: 17rem;
  height: 17rem;
  background: url(../../assets/ndzd/5-1.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 13.5%;
  top: 16%;
}
.wenzi {
  position: absolute;
  left: 10.8%;
  top: 15%;
  height: 28px;
  font-size: 16px;
  font-weight: 400;
  line-height: 42px;
  color: #272c28;
}
.zhuangtu {
  width: 90%;
  height: 10rem;
  position: absolute;
  left: 5%;
  top: 33%;
}
.zhu_wenzi {
  margin: 0;
  padding: 0;
  background: #fff;
  text-align: center;
  width: 100%;
  margin-top: -35px;
  padding-bottom: 10px;
}
.shouyi {
  position: absolute;
  top: 20%;
  width: 100%;
  background: #fff;
  padding: 5% 10%;
}
.shouyione {
  line-height: 30px;
  display: flex;
  justify-content: space-between;
}

.col1{
  color: #FF6C40;
  font-size: 20px;
   font-weight: bold;
}
.col2{
  color: #FFE700;
  font-size: 24px;
   font-weight: bold;
}
.col4{
  color: #FF813A;
  font-size: 28px;
   font-weight: bold;
}
.col3{
   color: #1890FF;
   font-size: 28px;
   font-weight: bold;
}
.col5{
   color: #826AF9;
   font-size: 28px;
   font-weight: bold;

}
.col6{
   color: #2CD9C5;
   font-size: 28px;
   font-weight: bold;

}

</style>